module.exports = __webpack_public_path__ + "static/media/portfolio1 (31).7fbb40c6.jpeg";